

import SettingsRoutes from '@/routes/settings'

export default [
  {
    path: '/',
    redirect: '/settings/loan'
  },
  {
    text: 'Settings',
    path: '/settings',
    redirect: '/settings/quote',
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/Settings.vue'),
    children: SettingsRoutes
  },
  {
    text: 'Embedded, No Waiters',
    path: '/add/embeddednowaiters',
    name: 'addembeddednowaiters',
    component: () => import(/* webpackChunkName: "addembeddednowaiters" */ '@/views/EmbeddedNoWaiters.vue')
  },
  {
    text: 'Embedded',
    path: '/add/embedded',
    name: 'addembedded',
    component: () => import(/* webpackChunkName: "addembedded" */ '@/views/Embedded.vue')
  },
  {
    text: 'Embedded Programmatic',
    path: '/add/embeddedprogrammatic',
    name: 'embeddedprogrammatic',
    component: () => import(/* webpackChunkName: "embeddedprogrammatic" */ '@/views/EmbeddedProgrammatic.vue')
  },
  {
    text: 'Modal',
    path: '/add/modal',
    name: 'widgetswithmodal',
    component: () => import(/* webpackChunkName: "widgetswithmodal" */ '@/views/WidgetsWithModal.vue')
  },
  {
    text: 'Reservation',
    path: '/reservation',
    name: 'reservation',
    component: () => import(/* webpackChunkName: "reservation" */ '@/views/Reservation.vue')
  },
  {
    text: 'Confirmation',
    path: '/confirmation',
    name: 'confirmation',
    component: () => import(/* webpackChunkName: "confirmation" */ '@/views/Confirmation.vue')
  },
  {
    text: 'Simplest Possible',
    path: '/simple',
    name: 'simple',
    component: () => import(/* webpackChunkName: "simple" */ '@/views/Simple.vue')
  }
]
